import React, { useCallback, useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import classes from "./RosterSearch.module.css";
import {
  getRosterDetails,
  deleteRoaster,
  viewTrainees,
  searchTrainee,
  updateRosterRequisitionMap,
} from "../../services/userServices";
import { useTranslation } from "react-i18next";
import { SnackBarStoreAction } from "Store/SnackBar";
import Grid from "@mui/material/Grid";
import AsttCard from "../../components/ASTT Card/asttCard";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import AsttDarkButton from "../../components/ASTTButtonDark/AsttButtonDark";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import moment from "moment";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import AddIcon from "@mui/icons-material/Add";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import { useDispatch } from "react-redux";
import { generalStoreActions } from "../../Store/GeneralStore";
import { bulkEditStoreAction } from "../../Store/BulkEdit";
import CloseIcon from "@mui/icons-material/Close";
import Checkbox from "@mui/material/Checkbox";
import BackdropComponent from "../../components/Spinner/Spinner";
import SnackBar from "components/SnackBar/SnackBar";
import Tooltip from "@mui/material/Tooltip";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import AsttButton from "components/AsttButton/AsttButton";
import AsttButtonLight from "components/ASTTButtonLight/AsttButtonLight";
import FileAttachmentDrawer from "components/FileAttachmentDrawer/FileAttachmentDrawer";
import RosterHistory from "components/RosterHistory/RosterHistory";
import RescheduleOrTransferDrawer from "components/RescheduleOrTransferDrawer/RescheduleOrTransferDrawer";
import Drawer from "@mui/material/Drawer";
import Modal from "@mui/material/Modal";
import SouthIcon from "@mui/icons-material/South";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import InfoIcon from "@mui/icons-material/Info";
import ZoomOutMapSharpIcon from "@mui/icons-material/ZoomOutMapSharp";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import applicationUsageLog from "../../utils/applicationUsagesLog";
import { Typography } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  padding: "0px",
};

const formatFTRRTimeStamp = (datetime) => {
  if (datetime) {
    moment(datetime).format("YYYY-MM-DD HH:mm:ss");
  }
  return "";
};

const validateBoolean = (data) => {
  if (data) {
    return data;
  }
  return "";
};

const validateText = (data) => {
  if (data) {
    return data;
  }
  return "";
};

const getIndexOf = (source, searchText) =>
  source.toLowerCase().indexOf(searchText.toLowerCase());

const GetSentimentIconForFtrr = (props) => {
  const { ftrrTimestamp } = props;
  if (ftrrTimestamp) {
    return (
      <SentimentSatisfiedAltIcon
        sx={{ color: "#008000" }}
      ></SentimentSatisfiedAltIcon>
    );
  }
  return (
    <SentimentVeryDissatisfiedIcon
      sx={{ color: "error.main" }}
    ></SentimentVeryDissatisfiedIcon>
  );
};

GetSentimentIconForFtrr.propTypes = {
  ftrrTimestamp: PropTypes.any,
};

const GetSentimentIconForE2N = (props) => {
  const { endorsedToNestingStatus } = props;
  if (endorsedToNestingStatus === "True") {
    return (
      <SentimentSatisfiedAltIcon
        sx={{ color: "#008000" }}
      ></SentimentSatisfiedAltIcon>
    );
  }
  return (
    <SentimentVeryDissatisfiedIcon
      sx={{ color: "error.main" }}
    ></SentimentVeryDissatisfiedIcon>
  );
};

const GetSentimentIconForProductionStatus = (props) => {
  const { productionStatus } = props;
  if (productionStatus === "Yes - Active") {
    return (
      <SentimentSatisfiedAltIcon
        sx={{ color: "#008000" }}
      ></SentimentSatisfiedAltIcon>
    );
  }
  return (
    <SentimentVeryDissatisfiedIcon
      sx={{ color: "error.main" }}
    ></SentimentVeryDissatisfiedIcon>
  );
};

GetSentimentIconForProductionStatus.propTypes = {
  productionStatus: PropTypes.any,
};

const RosterSearch = () => {
  const { classRequestId, rosterId } = useParams();
  const { t } = useTranslation(["rosterSearch"]);

  const [loading, setLoading] = useState([false]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [reqOpen, setReqOpen] = React.useState(false);
  const handleAddReqOpen = () => setReqOpen(true);
  const handleAddReqClose = () => {
    setReqOpen(false);
    setRequisitionid("");
  };
  const [requisitionid, setRequisitionid] = useState("");
  const [traineeShow, setTraineeShow] = useState("View");
  const snack = {
    open: false,
    message: "",
    severity: "",
  };
  const [understand, setUnderstand] = useState(false);
  const [state, setState] = React.useState({
    right: false,
  });
  const [attachmentState, setAttachmentState] = React.useState({
    right: false,
  });
  const [historyState, setHistoryState] = React.useState({
    right: false,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [allData, setAllData] = useState([]);
  const [userData, setUserData] = useState([]);

  const [roster, setRoster] = useState("");
  const [cloneStatus, setCloneStatus] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState();
  const [selectedClassRoster, setSelectedClassRoster] = useState("");

  const [userDataFiltered, setUserDataFiltered] = useState([]);
  const [bulkEditCount, setBulkEditCount] = useState([]);
  const [viewTraineeDataResult, setViewTraineeDataResult] = useState([]);
  const [trainerValue, setTrainerValue] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [sortOrder, setSortOrder] = useState(false);
  const [selectAllCheckbox, setSelectAllCheckbox] = useState(false);
  const [searchTextBoxValue, setSearchTextBoxValue] = useState("");
  const [classRequestIdState, setClassRequestIdState] = useState("");
  const [isRosterLocked, setIsRosterLocked] = useState(false);

  const ItemHeading = styled(Paper)(() => ({
    textAlign: "center",
    boxShadow: "none",
    fontWeight: 700,
  }));

  const Item = styled(Paper)(() => ({
    textAlign: "center",
    boxShadow: "none",
  }));

  useEffect(() => {
    let cancelled = false;

    const fetchDataOnLoad = async () => {
      try {
        await fetchData();

        if (!cancelled) {
          setLoading(false);
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch data on load:", error);
          setLoading(false);
        }
      }
    };

    fetchDataOnLoad();

    return () => {
      cancelled = true;
    };
  }, [classRequestId]);

  useEffect(
    () => () => {
      dispatch(generalStoreActions.updateClassRequestButton(false));
      dispatch(generalStoreActions.resetCloneDetails());
      applicationUsageLog(
        localStorage.getItem("User"),
        localStorage.getItem("EmailId"),
        "ASTT",
        "Roster Search",
      );
    },
    [],
  );

  const fetchData = async () => {
    setLoading(true);
    let userDetails;

    if (classRequestId === "null") {
      userDetails = await searchTrainee("rosterid", rosterId);

      if (userDetails.data.classRosters.length > 0) {
        localStorage.setItem(
          "parentClientCode",
          userDetails.data.classRosters[0].parentClientCode,
        );
        setClassRequestIdState(userDetails.data.classRosters[0].classRequestId);
      }
    } else {
      userDetails = await getRosterDetails(0, classRequestId);
    }

    if (userDetails.status === true) {
      setLoading(false);

      setAllData(userDetails.data.classRosters);
      const rosterLockTimeStamp =
        userDetails.data.classRosters[0]?.assignTraineesLockTimestamp;

      setIsRosterLocked(
        rosterLockTimeStamp !== null && rosterLockTimeStamp !== undefined,
      );

      dispatch(
        generalStoreActions.updateCloneRequestDetails(
          userDetails.data.cloneDetails,
        ),
      );

      if (userDetails.data.classRosters.length > 0) {
        dispatch(
          generalStoreActions.updateClassRequestId(
            userDetails.data.classRosters[0].classRequestId,
          ),
        );

        dispatch(
          generalStoreActions.updateProgramName(
            userDetails.data.classRosters[0].program,
          ),
        );
        if (userDetails.data.classRosters[0].project.split(",").length > 0) {
          dispatch(
            generalStoreActions.updateProjectName(
              userDetails.data.classRosters[0].project,
            ),
          );
        } else {
          dispatch(generalStoreActions.updateProjectName(""));
        }
      }

      setCloneStatus(userDetails.data.classRostersStatus);
      setSelectedStatus(userDetails.data.classRostersStatus[0]);
      let result = userDetails.data.classRosters.filter(
        (itm) =>
          itm.rosterStatusId ===
          userDetails.data.classRostersStatus[0].rosterStatusId,
      );
      result = result.map((item) => {
        return { ...item, expand: false };
      });
      setUserData(result);
      setUserDataFiltered(result);
    }
  };

  const handleDeleteRoster = (e) => {
    setUnderstand(false);
    setSelectedClassRoster(e);
    handleOpen();
  };

  const handleAddRequistion = (e) => {
    setSelectedClassRoster(e);
    handleAddReqOpen();
  };

  const statusChangeHandler = (rosterStatusId) => {
    setLoading(true);
    setTraineeShow("View");
    let result = allData.filter(
      (itm) => itm.rosterStatusId === Number(rosterStatusId),
    );
    setSelectedStatus(rosterStatusId);
    setUserDataFiltered(result);
    setUserData(result);
    setLoading(false);
  };

  const snackReset = () => {
    const obj = {
      open: false,
      message: "",
      severity: "",
    };
    dispatch(SnackBarStoreAction.updateSnack(obj));
  };

  const handleRosterConfigNavigate = (data, isRosterClone) => {
    data.requisitionId = data.requisitionId == null ? "" : data.requisitionId;
    localStorage.setItem("requisitionId", data.requisitionId);

    navigate(
      `/new-roster-config/edit/${data.classRosterId}/${data.classRequestId}/${isRosterClone}`,
    );
  };

  const hideTrainee = () => {
    setSelectAllCheckbox(false);
    setTraineeShow("View");
    setBulkEditCount(false);
    setSearchTextBoxValue("");
  };

  //Start View Trainee
  const viewTrainee = async (classRoster) => {
    setLoading(true);
    setSelectedClassRoster(classRoster);
    setTraineeShow("Hide");
    setViewTraineeDataResult([]);
    let viewTraineeData = await viewTrainees(classRoster.classRosterId);

    let data = userData.map((item) => {
      if (item.classRosterId === classRoster.classRosterId) {
        item.expand = true;
        item.datas = viewTraineeData.data || [];
        item.data = item.datas.map((item) => {
          return { ...item, isChecked: false };
        });
        setInitialData(item.datas);

        let traineeStatusDropdownWithCount = viewTraineeData.data.reduce(
          (acc, element) => {
            return {
              ...acc,
              [element.traineeStatus]: (acc[element.traineeStatus] || 0) + 1,
            };
          },
          {},
        );
        item.traineeStatusDropdown = traineeStatusDropdownWithCount;

        if (Object.keys(traineeStatusDropdownWithCount).includes("Active")) {
          setTrainerValue("Active");
          setViewTraineeDataResult(
            item.datas.filter((item) => item.traineeStatus === "Active"),
          );
        } else {
          setTrainerValue("All");
          setViewTraineeDataResult(item.datas);
        }

        let traineeStatusDropdownForBulk = [
          ...new Set(
            viewTraineeData.data.map((element) => {
              return {
                id: element.traineeStatusId,
                traineeStatus: element.traineeStatus,
              };
            }),
          ),
        ];
        traineeStatusDropdownForBulk = [
          ...new Map(
            traineeStatusDropdownForBulk.map((item) => [
              item["traineeStatus"],
              item,
            ]),
          ).values(),
        ];
        dispatch(
          bulkEditStoreAction.updateStatusDropdownDetails(
            traineeStatusDropdownForBulk,
          ),
        );
        return item;
      }
      return item;
    });
    setUserDataFiltered(data);
    setLoading(false);
  };

  const sortingTrainee = (id, val) => {
    setSortOrder(!sortOrder);
    if (sortOrder) {
      let filteredTraineeData = viewTraineeDataResult
        .toSorted((a, b) => {
          if (a[val] > b[val]) return 1;
          else if (b[val] > a[val]) return -1;
          return 0;
        })
        .slice();
      setViewTraineeDataResult(filteredTraineeData);
    } else {
      let filteredTraineeData = viewTraineeDataResult
        .toSorted((a, b) => {
          if (a[val] < b[val]) return 1;
          else if (b[val] < a[val]) return -1;
          return 0;
        })
        .slice();
      setViewTraineeDataResult(filteredTraineeData);
    }
  };

  const sortingFTRR = () => {
    setSortOrder(!sortOrder);
    if (sortOrder) {
      let filteredTraineeDataTrue = viewTraineeDataResult.filter(
        (item) => item.finalTrainingRosterReadyTimestamp != null,
      );
      let filteredTraineeDataFalse = viewTraineeDataResult.filter(
        (item) => item.finalTrainingRosterReadyTimestamp == null,
      );
      setViewTraineeDataResult(
        filteredTraineeDataTrue.concat(filteredTraineeDataFalse),
      );
    } else {
      let filteredTraineeDataTrue = viewTraineeDataResult.filter(
        (item) => item.finalTrainingRosterReadyTimestamp != null,
      );
      let filteredTraineeDataFalse = viewTraineeDataResult.filter(
        (item) => item.finalTrainingRosterReadyTimestamp == null,
      );
      setViewTraineeDataResult(
        filteredTraineeDataFalse.concat(filteredTraineeDataTrue),
      );
    }
  };

  const sortingE2N = () => {
    setSortOrder(!sortOrder);
    if (sortOrder) {
      let filteredTraineeDataTrue = viewTraineeDataResult.filter(
        (item) => item.endorsedToNestingStatus !== "True",
      );
      let filteredTraineeDataFalse = viewTraineeDataResult.filter(
        (item) => item.endorsedToNestingStatus === "True",
      );
      setViewTraineeDataResult(
        filteredTraineeDataTrue.concat(filteredTraineeDataFalse),
      );
    } else {
      let filteredTraineeDataTrue = viewTraineeDataResult.filter(
        (item) => item.endorsedToNestingStatus !== "True",
      );
      let filteredTraineeDataFalse = viewTraineeDataResult.filter(
        (item) => item.endorsedToNestingStatus === "True",
      );
      setViewTraineeDataResult(
        filteredTraineeDataFalse.concat(filteredTraineeDataTrue),
      );
    }
  };

  const sortingE2P = () => {
    setSortOrder(!sortOrder);
    if (sortOrder) {
      let filteredTraineeDataTrue = viewTraineeDataResult.filter(
        (item) => item.productionStatus === "Yes - Active",
      );
      let filteredTraineeDataFalse = viewTraineeDataResult.filter(
        (item) => item.productionStatus !== "Yes - Active",
      );
      setViewTraineeDataResult(
        filteredTraineeDataTrue.concat(filteredTraineeDataFalse),
      );
    } else {
      let filteredTraineeDataTrue = viewTraineeDataResult.filter(
        (item) => item.productionStatus === "Yes - Active",
      );
      let filteredTraineeDataFalse = viewTraineeDataResult.filter(
        (item) => item.productionStatus !== "Yes - Active",
      );
      setViewTraineeDataResult(
        filteredTraineeDataFalse.concat(filteredTraineeDataTrue),
      );
    }
  };

  const sortingDate = (col) => {
    setSortOrder(!sortOrder);
    if (sortOrder) {
      const sorted = [...viewTraineeDataResult].sort((a, b) => {
        if (a[col] === b[col]) return 0;
        else if (a[col] > b[col]) return 1;
        else return -1;
      });
      setViewTraineeDataResult(sorted);
    } else {
      const sorted = [...viewTraineeDataResult].sort((a, b) => {
        if (a[col] === b[col]) return 0;
        else if (a[col] < b[col]) return 1;
        else return -1;
      });
      setViewTraineeDataResult(sorted);
    }
  };

  const mystyle = {
    fontSize: "14px",
    color: "#d32f2f",
    fontWeight: "bold",
  };

  const filterSearchResults = (sourceData, filterValue) => {
    if (filterValue === "All") {
      return sourceData;
    } else {
      return sourceData.filter((item) => item.traineeStatus === filterValue);
    }
  };

  const filterSearchResultsByTextBoxValue = (searchResults) => {
    return searchResults.map((ele) => {
      if (
        getIndexOf(ele.oracleId, searchTextBoxValue) !== -1 ||
        getIndexOf(ele.preferredFirstName, searchTextBoxValue) !== -1 ||
        getIndexOf(ele.preferredLastName, searchTextBoxValue) !== -1
      ) {
        return ele;
      }
    });
  };

  const prepareTraineeDataResult = (data) => {
    return data.filter(Boolean).map((item) => {
      return { ...item, isChecked: false };
    });
  };

  const setupTraineeDataResult = (searchResults) => {
    if (searchTextBoxValue) {
      const items = filterSearchResultsByTextBoxValue(searchResults);
      setViewTraineeDataResult(prepareTraineeDataResult(items));
    } else {
      setViewTraineeDataResult(prepareTraineeDataResult(searchResults));
    }
  };

  const traineeFilter = (rosterId, event) => {
    setViewTraineeDataResult([]);
    setTrainerValue(event.target.value);
    setSelectAllCheckbox(false);
    setBulkEditCount(false);
    userData.map((item) => {
      let searchResults;
      if (item.classRosterId === rosterId) {
        item.expand = true;
        searchResults = filterSearchResults(item.datas, event.target.value);
        setupTraineeDataResult(searchResults);
        return item;
      }
      return item;
    });
  };

  const searchHandler = (rosterId, event) => {
    setSearchTextBoxValue(event.target.value);
    let items;
    if (trainerValue === "All") {
      items = initialData.map((ele) => {
        if (
          ele.oracleId.indexOf(event.target.value.toLowerCase()) !== -1 ||
          ele.preferredFirstName
            .toLowerCase()
            .indexOf(event.target.value.toLowerCase()) !== -1 ||
          ele.preferredLastName
            .toLowerCase()
            .indexOf(event.target.value.toLowerCase()) !== -1
        ) {
          return ele;
        }
      });
    } else {
      items = initialData.map((ele) => {
        if (
          trainerValue === ele.traineeStatus &&
          (ele.oracleId.indexOf(event.target.value.toLowerCase()) !== -1 ||
            ele.preferredFirstName
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) !== -1 ||
            ele.preferredLastName
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) !== -1)
        ) {
          return ele;
        }
      });
    }

    setViewTraineeDataResult(items.filter(Boolean));
  };

  const handleChangeChecked = (rosterId, e) => {
    let itemName = e.target.name;
    let checked = e.target.checked;

    if (itemName === "checkAll") {
      let traineeDataResult = viewTraineeDataResult.map((ele) => {
        return { ...ele, isChecked: checked };
      });
      let bulk = traineeDataResult.map((element) => {
        if (element.isChecked) {
          return {
            classTraineeId: element.classTraineeId,
            classRosterId: element.classRosterId,
            oracleId: element.oracleId,
            preferredFirstName: element.preferredFirstName,
            preferredLastName: element.preferredLastName,
            candidateId: element.candidateId,
            traineeStatus: element.traineeStatus,
          };
        }
      });
      setBulkEditCount(bulk.filter(Boolean));
      checked ? setSelectAllCheckbox(true) : setSelectAllCheckbox(false);
      dispatch(bulkEditStoreAction.updateTraineeDetails(bulk.filter(Boolean)));
      setViewTraineeDataResult(traineeDataResult);
    }
  };

  const onChangeTraineeChecked = (event, index, candidateId) => {
    viewTraineeDataResult[index].isChecked = event.target.checked;
    if (
      viewTraineeDataResult.filter((item) => item.isChecked === true).length ===
      viewTraineeDataResult.length
    ) {
      setSelectAllCheckbox(false);
    }

    let traineeDataResult = viewTraineeDataResult;
    let bulk = traineeDataResult.map((element) => {
      if (element.isChecked) {
        return {
          classTraineeId: element.classTraineeId,
          classRosterId: element.classRosterId,
          oracleId: element.oracleId,
          preferredFirstName: element.preferredFirstName,
          preferredLastName: element.preferredLastName,
          candidateId: element.candidateId,
          traineeStatus: element.traineeStatus,
        };
      }
    });

    setBulkEditCount(bulk.filter(Boolean));
    dispatch(bulkEditStoreAction.updateTraineeDetails(bulk.filter(Boolean)));
    setViewTraineeDataResult(traineeDataResult);
  };

  //End View Trainee

  const handleDeleteClassRoster = async () => {
    setLoading(true);
    const obj = {
      classRosterId: selectedClassRoster.classRosterId,
      modifiedBy: localStorage.getItem("User"),
    };
    await deleteRoaster(obj);
    handleClose();
    const userDetails = await getRosterDetails(
      0,
      classRequestId === "null" ? classRequestIdState : classRequestId,
    );
    if (userDetails.status === true) {
      setLoading(false);

      setAllData(userDetails.data.classRosters);

      dispatch(
        generalStoreActions.updateCloneRequestDetails(
          userDetails.data.cloneDetails,
        ),
      );
      if (userDetails.data.classRosters.length > 0) {
        dispatch(
          generalStoreActions.updateClassRequestId(
            userDetails.data.classRosters[0].classRequestId,
          ),
        );
      }

      setCloneStatus(userDetails.data.classRostersStatus);
      setSelectedStatus(cloneStatus[0]);
      let result = userDetails.data.classRosters.filter(
        (itm) =>
          itm.rosterStatusId ===
          userDetails.data.classRostersStatus[0].rosterStatusId,
      );
      result = result.map((item) => {
        return { ...item, expand: false };
      });
      setUserData(result);
      setUserDataFiltered(result);
    }
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    if (open === true) {
      hideTrainee();
    }

    setState({ ...state, [anchor]: open });
  };

  const BulkEditRedirection = useCallback(
    (rosterId) => {
      navigate(`/bulkedit/${rosterId}`);
    },
    [navigate],
  );

  const TraineeDetailsRedirection = (oracleId, firstName, lastName) => {
    window.open(
      `/trainee-details/${oracleId}/${firstName}/${lastName}`,
      "_blank",
    );
  };

  const multipleTraineeRedirection = (oracleId) => {
    window.open(`/searchResult/OracleId/${oracleId}`, "_self");
  };

  const drawerFileAttachment = (anchor, open, roster) => (event) => {
    setRoster(roster);
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setAttachmentState({ ...state, [anchor]: open });
  };

  const rosterHistoryDrawer = (anchor, open, roster) => (event) => {
    setRoster(roster);
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setHistoryState({ ...state, [anchor]: open });
  };

  const handleAssignTrainees = () => {
    navigate(`/assignTrainees/`, {
      state: {
        classRequestId:
          classRequestId === "null" ? classRequestIdState : classRequestId,
        classRosterId: rosterId,
      },
    });
  };

  const SaveRosterRequisitionMap = async (e) => {
    setLoading(true);

    if (requisitionid === "" || requisitionid === null) {
      const obj = {
        open: true,
        message: "Requisition ID field cannot be blank !",
        severity: "error",
      };
      dispatch(SnackBarStoreAction.updateSnack(obj));
    } else if (requisitionid.length < 5) {
      const obj = {
        open: true,
        message: "Requisition ID should contain 5 characters !",
        severity: "error",
      };
      dispatch(SnackBarStoreAction.updateSnack(obj));
    } else {
      const obj = {
        classRosterId: selectedClassRoster.classRosterId,
        requisitionId: requisitionid,
        modifiedBy: localStorage.getItem("User"),
      };

      const RosterRequisitionMapResponse =
        await updateRosterRequisitionMap(obj);
      if (RosterRequisitionMapResponse.status === true) {
        if (RosterRequisitionMapResponse.data[0].IsReqIdExists === true) {
          const obj = {
            open: true,
            message: `The mentioned Requisition ID is already added to roster ${selectedClassRoster.classRosterId} !`,
            severity: "error",
          };
          dispatch(SnackBarStoreAction.updateSnack(obj));
        } else {
          const obj = {
            open: true,
            message: "Saved Succesfully !!",
            severity: "success",
          };
          dispatch(SnackBarStoreAction.updateSnack(obj));

          handleAddReqClose();
          fetchData();
        }
      } else {
        const obj = {
          open: true,
          message: "Failed to add!",
          severity: "error",
        };
        dispatch(SnackBarStoreAction.updateSnack(obj));
      }
    }
    setLoading(false);
  };

  const handleChange = (event) => {
    setRequisitionid(event.target.value);
  };

  const handleLPClassRoster = (params) => {
    navigate(`/learnpoint/infoSection/ClassRoster`, {
      state: params.classRosterId,
    });
  };

  const showDeleteRosterButton = (rosterStatusId) =>
    rosterStatusId === 1 || rosterStatusId === 4;

  const showTrainees = (data) => {
    return (
      traineeShow === "Hide" &&
      selectedClassRoster.classRosterId === data.classRosterId &&
      data.expand
    );
  };

  const rescheduleClassName = (bulkEditLength, lockTimeStamp) => {
    if (bulkEditLength && !lockTimeStamp) {
      return "btn-cnf";
    }
    return "btn-cnf-disabled";
  };

  const isRescheduledDisable = (bulkEditLength, lockTimeStamp) =>
    !(bulkEditLength && !lockTimeStamp);

  const viewEditClassName = (length) =>
    length ? "btn-cnf" : "btn-cnf-disabled";

  return (
    <>
      {loading ? <BackdropComponent /> : null}
      <Drawer
        anchor={"right"}
        open={historyState["right"]}
        PaperProps={{
          sx: { width: "50%", backgroundColor: "#f2f2f2" },
        }}
        onClose={rosterHistoryDrawer("right", false)}
      >
        <RosterHistory
          data={roster}
          onClose={rosterHistoryDrawer("right", false)}
        ></RosterHistory>
      </Drawer>

      <Drawer
        anchor={"right"}
        open={attachmentState["right"]}
        PaperProps={{
          sx: { width: "50%", backgroundColor: "#f2f2f2" },
        }}
        onClose={drawerFileAttachment("right", false)}
      >
        {roster && (
          <FileAttachmentDrawer
            type="Classroster"
            data={roster}
            onClose={drawerFileAttachment("right", false)}
          ></FileAttachmentDrawer>
        )}
      </Drawer>

      <Drawer
        anchor={"right"}
        open={state["right"]}
        onClose={toggleDrawer("right", false)}
        PaperProps={{
          sx: { width: "70%", backgroundColor: "#f2f2f2" },
        }}
      >
        <RescheduleOrTransferDrawer
          roster={selectedClassRoster}
          onClose={toggleDrawer("right", false)}
          fetchData={fetchData}
        />
      </Drawer>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="flex-space-between red-background p-20px">
            <p className="white">
              {selectedClassRoster && (
                <p>
                  {t("cancelRoster")} {selectedClassRoster.classRosterId}
                </p>
              )}
            </p>
            <CloseIcon
              className="background-white"
              onClick={handleClose}
            ></CloseIcon>
          </div>
          <div className={`text-start ${classes.warningContainer}`}>
            <p className="redColor fs-1-5 text-center">{t("warning")}</p>
            <p className="m-5-0px ">{t("thisActionCannotbeUndone")}</p>
            <p className="m-5-0px ">
              {t("assignedMessage")}"
              <span className="redColor">{t("assignedError")}</span>"
            </p>
            <p className="m-5-0px ">
              {t("rosterStatusCancelled")}"
              <span className="redColor">{t("cancelled")}</span>"
            </p>
            <Checkbox
              checked={understand}
              onChange={(e) => {
                setUnderstand(e.target.checked);
              }}
            />
            <span className="redColor">{t("IUnderstand")}</span>
          </div>
          <div className="only-flex padding-20-40">
            <AsttButton
              onClick={(e) => handleDeleteClassRoster()}
              disabled={!understand}
            >
              {selectedClassRoster && (
                <p>
                  {" "}
                  {t("cancelRoster")} {selectedClassRoster.classRosterId}
                </p>
              )}
            </AsttButton>
            <AsttButtonLight onClick={handleClose}>
              {t("cancel")}
            </AsttButtonLight>
          </div>
        </Box>
      </Modal>

      <Modal
        open={reqOpen}
        onClose={handleAddReqClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 700,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            padding: "0px",
          }}
        >
          <div
            className={`flex-space-between p-20px ${
              window.location.host !== "astt.ttec.com"
                ? "env-devcolor"
                : "env-prodcolor"
            }`}
          >
            <p className="white">
              {selectedClassRoster && (
                <p>
                  ADD REQUISITION ID FOR ROSTER ID:{" "}
                  {selectedClassRoster.classRosterId}
                </p>
              )}
            </p>
            <CloseIcon
              className="background-white"
              onClick={handleAddReqClose}
            ></CloseIcon>
          </div>
          <div className={`text-start ${classes.warningContainer}`}>
            <div>
              <TextField
                label="Requisition ID :"
                id="outlined-basic"
                placeholder="Max 5 characters allowed"
                inputProps={{ maxLength: 5 }}
                sx={{ paddingLeft: "110px", paddingTop: "10px" }}
                onChange={handleChange}
              />
            </div>
            <br />
            <p className="m-5-0px ">
              Note: Adding a Requisition ID here will not add additional
              Trainees.That must be completed via the Assign Trainees process.
            </p>
          </div>
          <div className="only-flex padding-20-40">
            <AsttButton onClick={(e) => SaveRosterRequisitionMap(e)}>
              Save
            </AsttButton>
            <AsttButtonLight onClick={handleAddReqClose}>
              Cancel
            </AsttButtonLight>
          </div>
        </Box>
      </Modal>

      <div className="flex-space-between p-10px ">
        <div className={classes.itemStyle}>{userDataFiltered.length} ITEMS</div>

        <div className="flex-space-between align-center only-flex">
          <div className={classes.refreshTally}>
            <AsttButton
              buttonClass={classes.asttButton}
              onClick={handleAssignTrainees}
              disabled={isRosterLocked}
              {...(isRosterLocked && {
                title:
                  "Roster is locked, please unlock the roster to Assign trainees.",
              })}
            >
              {t("assignTrainees")}
            </AsttButton>
          </div>
          <div className="align-center only-flex">
            <Typography sx={{ width: "200px" }}>{t("rosterStatus")}</Typography>

            <select
              onChange={(e) => statusChangeHandler(e.target.value)}
              className="dropdown-css"
              value={selectedStatus}
              placeholder="Select an option"
            >
              {cloneStatus.map((value, index) => (
                <option key={value.rosterStatusId} value={value.rosterStatusId}>
                  {value.rosterStatus}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className={classes.tableContainer}>
        {userDataFiltered.length === 0 && (
          <p className={classes.noData}>No Data Found</p>
        )}
        {userDataFiltered.map((data, i) => {
          const rowKey = `${data.classRosterId}-${i}`;
          return (
            <AsttCard key={rowKey} parentClientStyle={{ padding: 20 }}>
              <Grid container spacing={2}>
                <Grid item xs={1}>
                  <ItemHeading>{t("rosterId")}</ItemHeading>
                </Grid>
                <Grid item xs={1}>
                  <ItemHeading>{t("wave")}</ItemHeading>
                </Grid>
                <Grid item xs={1}>
                  <ItemHeading>{t("requisitionId")}</ItemHeading>
                  <AddIcon
                    onClick={(e) => handleAddRequistion(data)}
                    sx={{ marginLeft: "40px", color: "#ec6517" }}
                  ></AddIcon>
                </Grid>
                <Grid item xs={1}>
                  <ItemHeading>{t("trainerName")}</ItemHeading>
                </Grid>
                <Grid item xs={1}>
                  <ItemHeading>{t("assignedTrainee")}</ItemHeading>
                </Grid>
                <Grid item xs={1}>
                  <UploadFileIcon
                    onClick={drawerFileAttachment("right", true, data)}
                    className={classes.icons}
                  ></UploadFileIcon>
                </Grid>
                <Grid className={classes.divider} item xs={0.4}>
                  {" "}
                  |{" "}
                </Grid>
                <Grid className={"only-flex"} item xs={1.2}>
                  <AsttDarkButton
                    onClick={() => {
                      dispatch(
                        generalStoreActions.activeTrainees(
                          data.numberOfActiveTrainees,
                        ),
                      );
                      handleRosterConfigNavigate(data, false);
                    }}
                  >
                    {t("rosterConfig")}
                  </AsttDarkButton>
                </Grid>
                <Grid className={"only-flex"} item xs={1}>
                  {data.ogChecklistURL !== null ? (
                    <>
                      <Tooltip
                        title="Click to Navigate for OG Checklist"
                        placement="top"
                        arrow
                      >
                        <a
                          rel="noreferrer"
                          target="_blank"
                          href={data.ogChecklistURL}
                        >
                          <FileOpenIcon
                            target="_blank"
                            className={classes.icons}
                          ></FileOpenIcon>
                        </a>
                      </Tooltip>
                    </>
                  ) : (
                    <>
                      <Tooltip
                        title="OG Checklist Removed"
                        placement="top"
                        arrow
                      >
                        <InsertDriveFileRoundedIcon
                          sx={{ color: "#ba000d", fontSize: "2.5rem" }}
                        />
                      </Tooltip>
                    </>
                  )}
                </Grid>
                <Grid
                  className={
                    "only-flex padding-r-20 direction-column height-100-per"
                  }
                  sx={{ paddingLeft: 0 }}
                  item
                  xs={1.4}
                >
                  {data.numberOfAssignedTrainees > 0 && (
                    <>
                      {traineeShow === "View" &&
                        selectedClassRoster.classRosterId ===
                          data.classRosterId && (
                          <AsttButtonLight onClick={() => viewTrainee(data)}>
                            {t("viewTrainee")}
                          </AsttButtonLight>
                        )}
                      {traineeShow === "Hide" &&
                        selectedClassRoster.classRosterId ===
                          data.classRosterId && (
                          <AsttButtonLight onClick={() => hideTrainee()}>
                            {t("hideTrainee")}
                          </AsttButtonLight>
                        )}
                      {selectedClassRoster.classRosterId !==
                        data.classRosterId && (
                        <AsttButtonLight onClick={() => viewTrainee(data)}>
                          {t("viewTrainee")}
                        </AsttButtonLight>
                      )}
                    </>
                  )}
                  {
                    <AsttButtonLight onClick={() => handleLPClassRoster(data)}>
                      LP CLASS ROSTER
                    </AsttButtonLight>
                  }
                  {data.rosterStatusId === 2 && (
                    <p className="redColor buttonContainer">CANCELLED</p>
                  )}
                </Grid>

                <Grid className={"only-flex"} item xs={1}>
                  <AsttDarkButton
                    onClick={rosterHistoryDrawer("right", true, data)}
                  >
                    {t("history")}
                  </AsttDarkButton>
                </Grid>
                {showDeleteRosterButton(data.rosterStatusId) ? (
                  <Grid className="only-flex redColor" item xs={1}>
                    <CancelPresentationIcon
                      onClick={(e) => handleDeleteRoster(data)}
                      className="fs-3rem"
                    ></CancelPresentationIcon>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
              <Grid className={"align-center"} container spacing={2}>
                <Grid item xs={1}>
                  <Item>{data.classRosterId}</Item>
                </Grid>
                <Grid item xs={1}>
                  <Item>{data.wave}</Item>
                </Grid>
                <Grid item xs={1}>
                  <Item>
                    <Tooltip title={data.requisitionId} arrow>
                      <p className={"overflow-ellipsis"}>
                        {data.requisitionId}
                      </p>
                    </Tooltip>
                  </Item>
                </Grid>
                <Grid item xs={1}>
                  <Item>
                    <a
                      className="blackColor"
                      href={`mailto:${data.trainerEmail}`}
                    >
                      {data.trainerName}
                    </a>
                  </Item>
                </Grid>
                <Grid className={"text-center"} item xs={1}>
                  <p>Total:{data.numberOfAssignedTrainees}</p>
                  <p className="blueColor">
                    Active:{data.numberOfActiveTrainees}
                  </p>
                  <p>
                    <span className="yelloColor">FTRR:{data.numberOfFTRR}</span>
                    <span className="greenColor"> E2P:{data.numberOfEtoP}</span>
                  </p>
                </Grid>
                <Grid item xs={1}></Grid>

                <Grid className={"text-center"} item xs={2}>
                  <span className="orangeColor">Lock -</span>{" "}
                  {data.rosterLockDate !== "" &&
                    moment(data.rosterLockDate).format("YYYY-MM-DD")}
                </Grid>
                <Grid className={"text-center"} item xs={2}>
                  <span className="orangeColor">Prod -</span>
                  {data.productionDate !== "" &&
                    moment(data.productionDate).format("YYYY-MM-DD")}
                </Grid>
                <Grid item xs={2}>
                  <span className="orangeColor">{t("created")} -</span>{" "}
                  <span className="flex-display">
                    {data.createdBy}

                    {data.createdDate !== "" && (
                      <p>({moment(data.createdDate).format("YYYY-MM-DD")})</p>
                    )}
                    {data.createdDate === "" && ""}
                  </span>
                </Grid>
              </Grid>

              {showTrainees(data) && (
                <>
                  <p>
                    <button
                      onClick={toggleDrawer("right", true)}
                      className={rescheduleClassName(
                        bulkEditCount.length,
                        data.assignTraineesLockTimestamp,
                      )}
                      disabled={isRescheduledDisable(
                        bulkEditCount.length,
                        data.assignTraineesLockTimestamp,
                      )}
                    >
                      {t("reschedule")}
                    </button>
                    <button
                      onClick={() => BulkEditRedirection(data.classRosterId)}
                      className={viewEditClassName(bulkEditCount.length)}
                      disabled={!bulkEditCount.length}
                    >
                      {t("viewEdit")}
                    </button>
                  </p>
                  {data.assignTraineesLockTimestamp && (
                    <p className="italic-text">
                      Note: Reschedule/Transfer is unavailable when Assign
                      Trainees is locked
                    </p>
                  )}
                  <div className="tableHolder">
                    <table width="100%">
                      <tr className="tableHolder1">
                        <th style={{ width: "3%" }}>
                          <input
                            type="checkbox"
                            checked={selectAllCheckbox}
                            name="checkAll"
                            onChange={($event) =>
                              handleChangeChecked(data.classRosterId, $event)
                            }
                          />
                        </th>
                        <th
                          style={{ width: "8%" }}
                          onClick={() =>
                            sortingTrainee(data.classRosterId, "oracleId")
                          }
                        >
                          <span>{t("Oracle Id")}</span>
                          <span>
                            <SouthIcon style={mystyle}></SouthIcon>
                            <ArrowUpwardIcon style={mystyle}></ArrowUpwardIcon>
                          </span>
                        </th>
                        <th
                          style={{ width: "10%" }}
                          onClick={() =>
                            sortingTrainee(
                              data.classRosterId,
                              "preferredFirstName",
                            )
                          }
                        >
                          <span>{t("First Name")}</span>
                          <span>
                            <SouthIcon style={mystyle}></SouthIcon>
                            <ArrowUpwardIcon style={mystyle}></ArrowUpwardIcon>
                          </span>
                        </th>
                        <th
                          style={{ width: "10%" }}
                          onClick={() =>
                            sortingTrainee(
                              data.classRosterId,
                              "preferredLastName",
                            )
                          }
                        >
                          <span>{t("Last Name")}</span>
                          <span>
                            <SouthIcon style={mystyle}></SouthIcon>
                            <ArrowUpwardIcon style={mystyle}></ArrowUpwardIcon>
                          </span>
                        </th>
                        <th
                          style={{ width: "10%" }}
                          onClick={() =>
                            sortingTrainee(data.classRosterId, "candidateId")
                          }
                        >
                          <span>{t("Candidate Id")}</span>
                          <span>
                            <SouthIcon style={mystyle}></SouthIcon>
                            <ArrowUpwardIcon style={mystyle}></ArrowUpwardIcon>
                          </span>
                        </th>
                        <th
                          style={{ width: "10%" }}
                          onClick={() =>
                            sortingTrainee(data.classRosterId, "employeeStatus")
                          }
                        >
                          <span>{t("Oracle Status")}</span>
                          <span>
                            <SouthIcon style={mystyle}></SouthIcon>
                            <ArrowUpwardIcon style={mystyle}></ArrowUpwardIcon>
                          </span>
                        </th>
                        <th
                          style={{ width: "8%" }}
                          onClick={() =>
                            sortingTrainee(data.classRosterId, "traineeStatus")
                          }
                        >
                          <span>{t("Trainee Status")}</span>
                          <select
                            id="traineeStatus"
                            name="traineeStatus"
                            value={trainerValue}
                            onChange={($event) =>
                              traineeFilter(data.classRosterId, $event)
                            }
                          >
                            <option value={"All"}>All</option>
                            {data.traineeStatusDropdown
                              ? Object.keys(data.traineeStatusDropdown).map(
                                  (key, idx) => (
                                    <option key={key} value={key}>
                                      {key} ({data.traineeStatusDropdown[key]})
                                    </option>
                                  ),
                                )
                              : null}
                          </select>
                        </th>
                        <th
                          style={{ width: "12%" }}
                          onClick={() =>
                            sortingTrainee(
                              data.classRosterId,
                              "techEquipmentSolution",
                            )
                          }
                        >
                          <span>{t("Tech Solution")}</span>
                          <span>
                            <SouthIcon style={mystyle}></SouthIcon>
                            <ArrowUpwardIcon style={mystyle}></ArrowUpwardIcon>
                          </span>
                        </th>
                        <th
                          style={{ width: "5%" }}
                          onClick={() => sortingFTRR()}
                        >
                          <span>FTRR</span>
                          <span>
                            <SouthIcon style={mystyle}></SouthIcon>
                            <ArrowUpwardIcon style={mystyle}></ArrowUpwardIcon>
                          </span>
                        </th>
                        <th
                          style={{ width: "5%" }}
                          onClick={() => sortingE2N()}
                        >
                          <span>E2N</span>
                          <span>
                            <SouthIcon style={mystyle}></SouthIcon>
                            <ArrowUpwardIcon style={mystyle}></ArrowUpwardIcon>
                          </span>
                        </th>
                        <th
                          style={{ width: "5%" }}
                          onClick={() => sortingE2P()}
                        >
                          <span>E2P</span>
                          <span>
                            <SouthIcon style={mystyle}></SouthIcon>
                            <ArrowUpwardIcon style={mystyle}></ArrowUpwardIcon>
                          </span>
                        </th>
                        <th
                          style={{ width: "10%" }}
                          onClick={() => sortingDate("createdDate")}
                        >
                          <span>Trainee Added</span>
                          <span>
                            <SouthIcon style={mystyle}></SouthIcon>
                            <ArrowUpwardIcon style={mystyle}></ArrowUpwardIcon>
                          </span>
                        </th>
                        <th style={{ width: "6%" }} colSpan="2">
                          <div className="only-flex">
                            {" "}
                            <input
                              type="text"
                              placeholder={t("Search")}
                              onChange={($event) =>
                                searchHandler(data.classRosterId, $event)
                              }
                            />
                            <SearchIcon
                              className={classes.searchIcon2}
                            ></SearchIcon>
                          </div>
                        </th>
                        <th></th>
                      </tr>

                      {viewTraineeDataResult.map((item, index) => {
                        const rowKey = `${item.candidateId}-${index}`;
                        return (
                          <tr key={rowKey}>
                            <td style={{ textAlign: "center" }}>
                              <input
                                type="checkbox"
                                name={item.candidateId}
                                value={item.candidateId}
                                checked={item.isChecked}
                                onChange={($event) =>
                                  onChangeTraineeChecked(
                                    $event,
                                    index,
                                    item.candidateId,
                                  )
                                }
                              />
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.oracleId}&nbsp;&nbsp;&nbsp;
                              <ZoomOutMapSharpIcon
                                onClick={(e) =>
                                  TraineeDetailsRedirection(
                                    item.oracleId,
                                    item.preferredFirstName,
                                    item.preferredLastName,
                                  )
                                }
                              ></ZoomOutMapSharpIcon>
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.preferredFirstName}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.preferredLastName}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.candidateId}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.employeeStatus}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.traineeStatus}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.techEquipmentSolution}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <span
                                title={formatFTRRTimeStamp(
                                  item.finalTrainingRosterReadyTimestamp,
                                )}
                              >
                                <GetSentimentIconForFtrr
                                  ftrrTimestamp={
                                    item.finalTrainingRosterReadyTimestamp
                                  }
                                />
                              </span>
                            </td>

                            <td style={{ textAlign: "center" }}>
                              <span
                                title={validateBoolean(
                                  item.endorsedToNestingStatus,
                                )}
                              >
                                <GetSentimentIconForE2N
                                  endorsedToNestingStatus={
                                    item.endorsedToNestingStatus
                                  }
                                />
                              </span>
                            </td>

                            <td style={{ textAlign: "center" }}>
                              <span title={validateText(item.productionStatus)}>
                                <GetSentimentIconForProductionStatus
                                  productionStatus={item.productionStatus}
                                />
                              </span>
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <span title={item.createdBy}>
                                {item.createdDate
                                  ? moment(item.createdDate).format(
                                      "YYYY-MM-DD hh:mm",
                                    )
                                  : item.createdDate}
                              </span>
                            </td>

                            <td style={{ textAlign: "center" }}>
                              {item.lateAdditionToRoster && (
                                <span title={item.message_LateAdditionToRoster}>
                                  <InfoIcon
                                    sx={{ color: "error.main" }}
                                  ></InfoIcon>
                                </span>
                              )}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.message_MultipleActiveRosters && (
                                <span
                                  title={item.message_MultipleActiveRosters}
                                >
                                  <WarningAmberIcon
                                    onClick={() =>
                                      multipleTraineeRedirection(item.oracleId)
                                    }
                                    sx={{ color: "error.main" }}
                                  ></WarningAmberIcon>
                                </span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </table>
                  </div>
                </>
              )}
            </AsttCard>
          );
        })}
      </div>
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
    </>
  );
};

export default RosterSearch;
